import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');

  // Check for OAuth errors in URL
  useEffect(() => {
    const oauthError = searchParams.get('error');
    const errorDescription = searchParams.get('description');
    if (oauthError) {
      setError(errorDescription || 'Authentication failed. Please try again.');
    }
  }, [searchParams]);

  const handleMicrosoftLogin = () => {
    const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000';
    window.location.href = `${apiUrl}/api/auth/login?redirect=/dashboard`;
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
    }}>
      <div style={{
        background: 'white',
        padding: '50px',
        borderRadius: '16px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        width: '100%',
        maxWidth: '450px',
      }}>
        {/* Logo */}
        <div style={{
          textAlign: 'center',
          marginBottom: '40px',
        }}>
          <span style={{ fontSize: '48px' }}>🖊️</span>
          <h1 style={{
            margin: '10px 0 5px',
            fontSize: '28px',
            color: '#1f2937',
          }}>
            Welcome Back
          </h1>
          <p style={{ color: '#6b7280', fontSize: '15px' }}>
            Sign in to manage your email signatures
          </p>
        </div>

        {/* Error Message */}
        {error && (
          <div style={{
            background: '#fee2e2',
            color: '#dc2626',
            padding: '12px',
            borderRadius: '8px',
            marginBottom: '30px',
            fontSize: '14px',
            borderLeft: '4px solid #dc2626',
          }}>
            {error}
          </div>
        )}

        {/* Microsoft Sign In */}
        <button
          onClick={handleMicrosoftLogin}
          style={{
            width: '100%',
            padding: '12px',
            background: 'white',
            color: '#5e5e5e',
            border: '2px solid #e5e7eb',
            borderRadius: '8px',
            fontSize: '15px',
            fontWeight: '500',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
          }}
        >
          <svg width="20" height="20" viewBox="0 0 21 21">
            <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
            <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
            <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
          </svg>
          Sign in with Microsoft
        </button>

        {/* Sign Up Link */}
        <div style={{
          textAlign: 'center',
          marginTop: '30px',
          fontSize: '14px',
          color: '#6b7280',
        }}>
          New to VirtueSign?{' '}
          <a
            href={`${import.meta.env.VITE_API_URL || ''}/oauth/consent`}
            style={{
              color: '#667eea',
              textDecoration: 'none',
              fontWeight: '600',
            }}
          >
            Get Started
          </a>
        </div>

        {/* Back to Home */}
        <div style={{
          textAlign: 'center',
          marginTop: '20px',
        }}>
          <button
            onClick={() => navigate('/')}
            style={{
              background: 'none',
              border: 'none',
              color: '#9ca3af',
              fontSize: '14px',
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
          >
            ← Back to home
          </button>
        </div>
      </div>
    </div>
  );
}
